import BloodGlucoseClassification from "@/model/BloodGlucoseClassification";

const backgroundColorForClassification = (classification: BloodGlucoseClassification) => {
  switch (classification) {
    case "emergency-low":
      return "bg-measurement-background-emergency";
    case "critical-low":
      return "bg-measurement-background-warning";
    case "low":
      return "bg-measurement-background-acceptable";
    case "acceptable":
      return "bg-measurement-background-acceptable";
    case "elevated":
      return "bg-measurement-background-warning";
    case "critical-high":
      return "bg-measurement-background-emergency";
    default:
      return "bg-measurement-background-acceptable";
  }
};

const foregroundColorForClassification = (classification: BloodGlucoseClassification) => {
  switch (classification) {
    case "emergency-low":
      return "text-measurement-text-emergency";
    case "critical-low":
      return "text-measurement-text-warning";
    case "low":
      return "text-measurement-text-acceptable";
    case "acceptable":
      return "text-measurement-text-acceptable";
    case "elevated":
      return "text-measurement-text-warning";
    case "critical-high":
      return "text-measurement-text-emergency";
    default:
      return "text-measurement-text-acceptable";
  }
};

export { backgroundColorForClassification, foregroundColorForClassification };
